"use strict";

/** @ContourPreviewController */
function ContourPreviewController(
  $scope,
  $window,
  AnalyticsService,
  ContourPreviewActions,
  ContourPreviewService,
  DataExportService,
  Flux,
  IdentityService,
  SaturnGrowl
) {
  const ContourPreviewStore = Flux.Store.get("ContourPreviewStore");
  const DataCaptureStore = Flux.Store.get("DataCaptureStore");

  const getUnits = () => {
    const currentSite = ContourPreviewService.getSite();
    const meta =
      currentSite && currentSite.hasOwnProperty("project")
        ? JSON.parse(currentSite.project.meta)
        : undefined;
    const currentUnits =
      meta && meta.hasOwnProperty("units") ? meta.units : "imperial";

    return currentUnits;
  };

  const baseApi = IdentityService.getApiUri();

  const sendAnalytics = (name, options) => {
    AnalyticsService.track("[CORE] Contour", name, options);
  };

  this.data = ContourPreviewService.getData();
  this.visible = false;
  this.requestData = null;

  this.resetOptions = () => {
    if (!this.data || !this.data.dataCapture || !this.data.site) {
      return;
    }

    this.contourOptions = {
      units: getUnits(),
      ratio: "10",
      interval: "medium",
      dataCaptureId: this.data.dataCapture.id,
      uuid: this.data.uuid,
      siteName: this.data.site.name
    };
  };

  this.getIntervalValue = () => {
    const chosenValue = this.contourOptions.interval;
    const units = this.contourOptions.units;
    const intervalValues = {
      small: {
        metric: 0.5,
        imperial: 1
      },
      medium: {
        metric: 1,
        imperial: 3
      },
      large: {
        metric: 2,
        imperial: 6
      }
    };

    return intervalValues[chosenValue][units];
  };

  this.showDialog = () => {
    this.resetOptions();
    this.visible = ContourPreviewStore.get("dialogVisibility");
  };

  this.exportContour = () => {
    DataExportService.toggleExportProcessing("DXF");
    this.contourOptions.interval = this.getIntervalValue();
    this.contourOptions.ratio = parseInt(this.contourOptions.ratio, 10);

    const data = {
      formula: this.contourOptions,
      type: "dxf",
      userId: IdentityService.getUser().id
    };

    ContourPreviewActions.ExportContour.dispatch(data);

    this.hideModal();

    sendAnalytics("Request Contour Export", {
      units: data.formula.units,
      ratio: data.formula.ratio,
      interval: data.formula.interval,
      dataCaptureId: data.formula.dataCaptureId,
      uuid: data.formula.uuid,
      siteName: data.formula.siteName
    });

    SaturnGrowl.newGrowl(
      "Your Contour Lines are processing for export. This can take several minutes. We'll let you know as soon as your file is ready.",
      {
        id: "contour-processing",
        time: -1
      }
    );
  };

  this.hideModal = () => {
    this.visible = false;
  };

  this.requestCompleted = payload => {
    DataExportService.toggleExportProcessing("DXF");
    this.requestData = payload.data;

    sendAnalytics("Request Completed", {
      site: ContourPreviewService.getSite(),
      dataCapture: ContourPreviewService.getDataCapture(),
      uuid: ContourPreviewService.getUuid()
    });

    SaturnGrowl.removeGrowl({
      id: "contour-processing"
    });

    SaturnGrowl.newGrowl("Your Contour Lines are ready for export.", {
      id: "contour-completed",
      time: -1,
      cta: {
        label: "Download Contours",
        callback: this.downloadContour.bind(this)
      }
    });
  };

  this.requestFailed = () => {
    DataExportService.toggleExportProcessing("DXF");

    sendAnalytics("Request Failed", {
      site: ContourPreviewService.getSite(),
      dataCapture: ContourPreviewService.getDataCapture(),
      uuid: ContourPreviewService.getUuid()
    });

    SaturnGrowl.removeGrowl({
      id: "contour-processing"
    });

    SaturnGrowl.newGrowl(
      "A problem occurred while processing your contour lines. Please try again.",
      {
        id: "contour-error",
        time: -1,
        type: "alert"
      }
    );
  };

  this.downloadContour = () => {
    const url = `${baseApi}data_exports/${this.requestData.hash}/download`;
    $window.location.href = url;

    sendAnalytics("Contour Downloaded", { url });

    SaturnGrowl.removeGrowl({
      id: "contour-completed"
    });
  };

  this.updateDataCapture = () => {
    const currDC = DataCaptureStore.get("current");
    ContourPreviewService.setDataCapture(currDC);
    if (currDC.processingJob && currDC.processingJob.uuid) {
      ContourPreviewService.setUuid(currDC.processingJob.uuid);
    }

    this.data = ContourPreviewService.getData();
    this.resetOptions();
  };

  ContourPreviewStore.on(
    ContourPreviewStore.Events.Changed,
    this.showDialog.bind(this),
    $scope
  );
  ContourPreviewStore.on(
    ContourPreviewStore.Events.RequestCompleted,
    this.requestCompleted.bind(this),
    $scope
  );
  ContourPreviewStore.on(
    ContourPreviewStore.Events.RequestFailed,
    this.requestFailed.bind(this),
    $scope
  );
  DataCaptureStore.on(
    DataCaptureStore.Events.Changed,
    this.updateDataCapture.bind(this),
    $scope
  );
}

ContourPreviewController.$inject = [
  "$scope",
  "$window",
  "AnalyticsService",
  "ContourPreviewActions",
  "ContourPreviewService",
  "DataExportService",
  "sbFlux",
  "IdentityService",
  "SaturnGrowl"
];

module.exports = ContourPreviewController;



// WEBPACK FOOTER //
// ./src/app/shared/contourPreview/ContourPreviewController.js